import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";
import Search from "../Search";

interface Props {
  onSearch: (val: string) => void;
  query: string;
}

const MerchantHeader = ({ onSearch, query }: Props) => {
  const navigate = useNavigate();

  const navigateToAddMerchant = () => {
    navigate(`/admin/add-merchant`);
  };

  return (
    <StyledMerchantHeader>
      <StyledPageHeader>Merchant</StyledPageHeader>
      <MerchantHeaderActions>
        <Search placeholder="Search" onChange={onSearch} value={query} />
        <Button
          variant="filled"
          label="Add User"
          color={Colors.red}
          onClick={navigateToAddMerchant}
        ></Button>
      </MerchantHeaderActions>
    </StyledMerchantHeader>
  );
};

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledMerchantHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 3.5rem;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0.5rem;
  }
`;

const MerchantHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    padding: 1.5rem;
  }
`;
export default MerchantHeader;
